import { t } from "ttag";

import { useAdminSetting } from "metabase/api/utils";
import { LoadingAndErrorWrapper } from "metabase/common/components/LoadingAndErrorWrapper";
import type { EnterpriseSettings } from "metabase-types/api";

import { AuthCard } from "../../components/AuthCard";
import { SAML_SCHEMA } from "../../constants";

export function SamlAuthCard() {
  const {
    value: isConfigured,
    updateSetting,
    updateSettings,
    settingDetails,
    isLoading,
  } = useAdminSetting("saml-configured");
  const { value: isEnabled } = useAdminSetting("saml-enabled");

  const handleDeactivate = () => {
    return updateSettings(
      SAML_SCHEMA.getDefault() as Partial<EnterpriseSettings>,
    );
  };

  if (isLoading) {
    return <LoadingAndErrorWrapper loading />;
  }

  return (
    <AuthCard
      type="saml"
      name={t`SAML`}
      description={t`Allows users to log in to Metabase via a SAML identity provider.`}
      isConfigured={!!isConfigured}
      isEnabled={!!isEnabled}
      onDeactivate={handleDeactivate}
      onChange={(newValue) =>
        updateSetting({
          key: "saml-enabled",
          value: newValue,
        })
      }
      setting={settingDetails}
    />
  );
}
